import React from "react";
// import { Container, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import homeVideo from "../assets/video/vid1.mp4";



export default function Travelexplore() {
  return (
    <section className="hometravel-explore container-fluid py-10 ">
      
  <div className="hometravel-bg">
   <video autoPlay loop muted playsInline className="video-bg">
    <source src={homeVideo} type="video/mp4" />
  </video>
</div>

    </section>
  );
}
